import { Wrench } from 'lucide-react'
import { useEffect, useState } from 'react'
import { API_URL } from '../../config/api'

interface Props {
  agentId: number
}

export default function AgentSkillsTab({ agentId }: Props) {
  const [skills, setSkills] = useState<any[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetch(`${API_URL}/api/agents/${agentId}/skills`)
      .then(r => r.json())
      .then(d => { setSkills(d.skills ?? []); setLoading(false) })
      .catch(() => setLoading(false))
  }, [agentId])

  if (loading) return <div className="ad-loading">Loading skills...</div>
  if (!skills.length) return (
    <div className="ad-empty"><Wrench size={32} /><p>No skills found</p></div>
  )

  return (
    <div className="ad-skills-list">
      {skills.map((s: any) => (
        <div key={s.id} className="ad-skill-row">
          <div className="ad-skill-icon">
            <Wrench size={14} />
          </div>
          <div className="ad-skill-info">
            <div className="ad-skill-name">{s.name}</div>
            {s.description && <div className="ad-skill-desc">{s.description?.slice(0, 80)}</div>}
            <div className="ad-skill-meta">
              {s.category && <span className="ad-skill-cat">{s.category}</span>}
              {s.run_count > 0 && <span className="ad-skill-runs">{s.run_count} runs</span>}
            </div>
          </div>
          <button className="ad-skill-run-btn" onClick={() =>
            window.dispatchEvent(new CustomEvent('runai:open-window', { detail: 'skills-window' }))
          }>
            Run
          </button>
        </div>
      ))}
    </div>
  )
}
